import { t } from 'i18next';
import type { Env } from '../../../context/env-context';

export function getBillingDurationReadable(duration: string | undefined): string {
  switch (duration) {
    case 'year':
      return t('features:account.pages.plan_page.billing_duration.year');
    default:
      return t('features:account.pages.plan_page.billing_duration.default');
  }
}

export function doesBillingProviderApplyTAX(provider: string | undefined): boolean {
  switch (provider) {
    case 'stripe':
      return true;
    default:
      return false;
  }
}

export function readableBillingInfoTextKey(key: string | undefined): string {
  switch (key) {
    case 'stripe':
      return t('features:account.pages.plan_page.billing_info.stripe');
    case 'shopify':
      return t('features:account.pages.plan_page.billing_info.shopify');
    case 'hubspot':
      return t('features:account.pages.plan_page.billing_info.hubspot');
    case 'wix':
      return t('features:account.pages.plan_page.billing_info.wix');
    default:
      return '';
  }
}

const pendingPlanProviders = ['stripe', 'hubspot', 'test'];

export function pendingPlanIsConfirmable(env: Env): boolean {
  if (env.environment !== 'live' || !env.billing.has_pending_plan || !env.billing.pending_plan) {
    return false;
  }
  return pendingPlanProviders.includes(env.billing.pending_plan.billing_provider_name);
}
